'use client';

import { c as _c } from "react/compiler-runtime";
import { useActiveWallet } from '@morfi/backend-sdk-v2/client';
import { useEffect } from 'react';
import { useMultiWalletFeature } from '@/providers/multi-wallet-feature-provider';
import { usePortfolioWalletSelectionStore } from '@/stores/portfolio-wallet-selection';
import type { Wallet } from '@/types/auth';
export type SelectionMode = 'all' | 'single';
export interface ResolvedSelection {
  mode: SelectionMode;
  wallet: Wallet | null;
  addresses: string[];
}
export function useResolvedSelection(wallets) {
  const $ = _c(6);
  const selection = usePortfolioWalletSelectionStore(_temp);
  const setSelection = usePortfolioWalletSelectionStore(_temp2);
  const {
    activeWallet
  } = useActiveWallet();
  const {
    state: gateState,
    primaryWallet
  } = useMultiWalletFeature();
  const activeWalletId = activeWallet?.id ?? null;
  const activeWallets = wallets.filter(_temp3);
  const resolvedPrimary = gateState === "on" || primaryWallet === null || primaryWallet.archivedAt !== null || primaryWallet.isAvailable === false ? null : activeWallets.find(wallet => wallet.id === primaryWallet.id) ?? null;
  const needsGateRepair = gateState !== "on" && selection !== "active";
  const explicitMatch = selection === "all" || selection === "active" ? null : activeWallets.find(wallet_0 => wallet_0.id === selection) ?? null;
  const isInvalid = selection !== "all" && selection !== "active" && explicitMatch === null;
  let t0;
  let t1;
  if ($[0] !== gateState || $[1] !== isInvalid || $[2] !== needsGateRepair || $[3] !== setSelection) {
    t0 = () => {
      if (needsGateRepair || gateState === "on" && isInvalid) {
        setSelection("active");
      }
    };
    t1 = [gateState, isInvalid, needsGateRepair, setSelection];
    $[0] = gateState;
    $[1] = isInvalid;
    $[2] = needsGateRepair;
    $[3] = setSelection;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  if (gateState !== "on") {
    return {
      mode: "single",
      wallet: resolvedPrimary,
      addresses: resolvedPrimary === null ? [] : [resolvedPrimary.address]
    };
  }
  const all = () => ({
    mode: "all",
    wallet: null,
    addresses: activeWallets.map(_temp4)
  });
  if (selection === "all") {
    return all();
  }
  if (explicitMatch !== null) {
    return {
      mode: "single",
      wallet: explicitMatch,
      addresses: [explicitMatch.address]
    };
  }
  const activeMatch = activeWalletId !== null ? activeWallets.find(w_1 => w_1.id === activeWalletId) ?? null : null;
  if (activeMatch !== null) {
    return {
      mode: "single",
      wallet: activeMatch,
      addresses: [activeMatch.address]
    };
  }
  return all();
}
function _temp4(w_0) {
  return w_0.address;
}
function _temp3(w) {
  return w.archivedAt === null;
}
function _temp2(s_0) {
  return s_0.setSelection;
}
function _temp(s) {
  return s.selection;
}